module.exports = __webpack_public_path__ + "static/img/5.6e4759d9.jpg";